import { Box, DialogActions, DialogContent, Grid, List, ListItem, Paper, styled, Typography } from "@mui/material";

export const StyledInformacionEmpresa = {
  GridContainer: styled(Grid)(({ theme }) => ({
    display: "flex",
    flexDirection: "column"
  })),
}

export const StyledDatosGenerales = {
  List: styled(List)(({ theme }) => ({
    padding: 0,
  })),
  ListItem: styled(ListItem)(({ theme }) => ({
    padding: "5px",
    display: "block",
    wordWrap: "break-word",
  })),
}

export const StyledDatosEmpresa = {
  List: styled(List)(({ theme }) => ({
    padding: 0,
  })),
  ListItem: styled(ListItem)(({ theme }) => ({
    padding: "5px",
    display: "flex",
    wordWrap: "break-word",
  })),
  Label: styled(Typography)(({ theme }) => ({
    marginRight: "15px",
  })),
}

export const StyledDomicilio = {
  FormikInput: styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    flex: 1,
  })),
  ErrorDiv: styled('div')(({ theme }) => ({
    height: "20px",
  })),
  ButtonContainer: styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    "& button": {
      color: `${theme.palette.primary.main}`,
      marginTop: 5,
      borderRadius: "10px",
      "& :hover": {
        borderBottom: `${theme.palette.primary.main} 1px solid`,
      },
    },
  })),
}

export const StyledDatosDeContacto = {
  DatosDeContactoContainer: styled(Grid)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    paddingRight: 35,
    paddingLeft: 35,
    marginTop: 15,
  })),
  FormikInput: styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
  })),
  ErrorDiv: styled('div')(({ theme }) => ({
    height: "20px",
  })),
  ButtonContainer: styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    marginTop: 10,
    "& button": {
      color: `${theme.palette.primary.main}`,
      marginTop: 5,
      borderRadius: "10px",
      "& :hover": {
        borderBottom: `${theme.palette.primary.main} 1px solid`,
      },
    },
  })),
}

export const StyledContratoCardContainer = {
  Container: styled('div')(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  })),
}
export const StyledContratoCard = {
  Container: styled(Paper)(({ theme }) => ({
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    padding: "10px 20px",
    marginBottom: "10px",
    alignItems: "center",
  })),

  Icon: styled('div')(({ theme }) => ({
    marginRight: "15px",
    color: `${theme.palette.primary.main}`,
    cursor: "pointer",
  })),

  Text: styled(Typography)(({ theme }) => ({
    fontSize: "14px",
    fontWeight: "600",
    margin: "auto 0px",
  })),

  ContainerIcon: styled(Box)(({ theme, pointer }) => ({
    display: "flex",
    ...(pointer && {
      cursor: "pointer",
    })
  })),

  ContainerText: styled('div')(({ theme }) => ({
    display: "flex",
  })),
}

export const StyledModalSendEmail = {
  ContainerBody: styled(DialogContent)(({ theme }) => ({
    width: 550,
    height: 180,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  })),
  FormikFieldContainer: styled('div')(({ theme }) => ({
    width: 500,
    marginTop: -50,
  })),
  ContainerButtons: styled(DialogActions)(({ theme }) => ({
    position: "absolute",
    bottom: 10,
    right: 10,
  })),
}